import React, { PureComponent } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './Trigger-Styles.css';

import Modal from './Modal';
import FeedbackIcon from './feedback.svg';
import CloseIcon from './close.svg';
import styled from 'styled-components';
import { getColorValue } from 'shared/util/theme';
import { feedbackStyles } from 'builder/util/constants';
import { FeedbackFormField } from 'shared/widgets/Form/types';

const StyledTriggerDiv = styled.div<{
  backgroundColor: string;
  textColor: string;
  zIndex: number;
}>`
  background-color: ${p => getColorValue(p.backgroundColor, p.theme)};
  color: ${p => getColorValue(p.textColor, p.theme)};
  zindex: ${p => p.zIndex};
`;

const StyledButton = styled.button<{
  backgroundColor: string;
  textColor: string;
  feedbackButtonPosition?: 'Bottom' | 'Center';
  fontSize?: string;
}>`
  writing-mode: vertical-lr;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 8px 8px 0;
  border: none;
  cursor: pointer;
  padding: 24px 14px;
  font-family: 'OptumSans';
  font-size: ${p => (p.fontSize ? `${p.fontSize}px` : '14px')};
  font-weight: 500;
  color: ${p => getColorValue(p.textColor, p.theme)};
  background: ${p => getColorValue(p.backgroundColor, p.theme)};
  ${p =>
    p.feedbackButtonPosition === 'Center'
      ? `
        position: fixed;
        top: 50%;
        right: 0;
        transform: translateY(-50%) rotate(180deg);
      `
      : `
        position: absolute;
        bottom: 150px;
        top: auto;
        right: -10px;
        transform: rotate(180deg);
      `}
`;

export interface TriggerProps {
  feedbackTypes: Array<string>;
  enableFeedbackTypes?: boolean;
  buttonColor: string;
  textColor: string;
  hoverBorderColor: string;
  fontFamily: string;
  fontSize: string;
  feedbackStyle: string;
  feedbackButtonPosition?: 'Bottom' | 'Center';
  issueFeedBackTypeEmailList: string;
  ideaFeedbackTypeEmailList: string;
  bugFeedbackTypeEmailList: string;
  allFeedbackTypeEmailList: string;
  postSubmitButtonMsg: string;
  submitButtonMsg: string;
  formfields: Array<FeedbackFormField>;
  zIndex: number;
  siteId: number;
  siteName: string;
  specifyEmailPerFeedbackType: boolean;
}

class Trigger extends PureComponent<TriggerProps> {
  state = {
    modal: false,
  };

  triggerModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  render() {
    let { modal } = this.state;
    let { props } = this;
    let {
      specifyEmailPerFeedbackType,
      issueFeedBackTypeEmailList,
      ideaFeedbackTypeEmailList,
      bugFeedbackTypeEmailList,
      allFeedbackTypeEmailList,
    } = this.props;

    return (
      <React.Fragment>
        {props.feedbackStyle === feedbackStyles[1] && (
          <StyledTriggerDiv
            className="frf-trigger-button"
            data-test-id={'feedback-trigger-button'}
            backgroundColor={props.buttonColor}
            textColor={props.textColor}
            zIndex={props.zIndex}
            onClick={this.triggerModal}
          >
            <div
              className={modal ? 'frf-feedback-icon-open' : 'frf-feedback-icon'}
              style={{
                fill: props.textColor,
              }}
            >
              {modal ? <CloseIcon /> : <FeedbackIcon />}
            </div>
          </StyledTriggerDiv>
        )}
        {props.feedbackStyle === feedbackStyles[0] && (
          <StyledButton
            data-test-id="feedback-pinned-tab-button"
            backgroundColor={props.buttonColor}
            textColor={props.textColor}
            feedbackButtonPosition={props.feedbackButtonPosition}
            fontSize={props.fontSize}
            onClick={this.triggerModal}
          >
            Feedback
          </StyledButton>
        )}

        <TransitionGroup component={null}>
          {modal && (
            <CSSTransition
              in={modal}
              classNames="frf-dialog"
              timeout={{
                enter: 300,
                exit: 300,
              }}
            >
              <Modal
                feedbackTypes={props.feedbackTypes}
                enableFeedbackTypes={props.enableFeedbackTypes}
                buttonColor={props.buttonColor}
                textColor={props.textColor}
                fontFamily={props.fontFamily}
                fontSize={props.fontSize}
                hoverBorderColor={props.hoverBorderColor}
                postSubmitButtonMsg={props.postSubmitButtonMsg}
                submitButtonMsg={props.submitButtonMsg}
                triggerModal={this.triggerModal}
                modalOpen={this.state.modal}
                zIndex={props.zIndex}
                issueFeedBackTypeEmailList={
                  specifyEmailPerFeedbackType
                    ? issueFeedBackTypeEmailList
                    : allFeedbackTypeEmailList
                }
                ideaFeedbackTypeEmailList={
                  specifyEmailPerFeedbackType
                    ? ideaFeedbackTypeEmailList
                    : allFeedbackTypeEmailList
                }
                bugFeedbackTypeEmailList={
                  specifyEmailPerFeedbackType
                    ? bugFeedbackTypeEmailList
                    : allFeedbackTypeEmailList
                }
                allFeedbackTypeEmailList={allFeedbackTypeEmailList}
                formfields={props.formfields}
                siteId={props.siteId}
                siteName={props.siteName}
              />
            </CSSTransition>
          )}
        </TransitionGroup>
      </React.Fragment>
    );
  }
}

export default Trigger;
